/**
 * Safely renders a value as a string.
 * Handles null, undefined, objects (by stringifying or extracting body), etc.
 */
export const renderText = (v) => {
    if (v === null || v === undefined) return "";
    
    if (typeof v === "string") return v;
    if (typeof v === "number") return String(v);
    
    if (typeof v === "boolean") return "";

    if (typeof v === "object") {
        if (v.body !== undefined && v.body !== null) {
             if (typeof v.body === 'object') {
                 return JSON.stringify(v.body);
             }
             return String(v.body);
        }

        if (v instanceof Date) {
            return v.toISOString();
        }

        // If it is an array
        if (Array.isArray(v)) {
            return JSON.stringify(v);
        }
        
        try {
            return JSON.stringify(v);
        } catch (e) {
            return "";
        }
    }
    
    return String(v);
};
